<template>
  <testimonial
    :items="items"
    headline="Testimonials from AI engineers hired by IM from our previous courses"
  ></testimonial>
</template>

<script>
import Testimonial from '../IsaData/Testimonial.vue'
export default {
  name: 'learnerssaying',
  components: {
    Testimonial,
  },
  data() {
    return {
      items: [
        {
          title: 'Ariq Rahmamd',
          subtitle: 'AI Engineer, Inteligent Machines',
          body:
            '"Data Science is a field that is linked to a wide array of fields i.e. Engineering, Business, Finance, etc. The knowledge I earned from this program will definitely help me improve my career prospects and build a sound understanding of risk management, data analysis, and data visualization."',
        },
        {
          title: 'Nazia Hossain',
          subtitle: 'AI Engineer, Inteligent Machines',

          body:
            '"Data Science is a relatively new field hence learning it especially in Bangladesh is always a challenge. But this course was by far one of the most helpful Data Science training I have come across as it helped me solidify my foundation of the subject."',
        },
        {
          title: 'Fahim Mahmood',
          subtitle: 'AI Engineer, Inteligent Machines',

          body:
            '"For me, understanding how versatile this field can be was the most amazing experience. I also loved the fact that our mentors inspired us to formulate our own path so that we can discover newer ways to apply our knowledge of Data Science."',
        },
      ],
    }
  },
}
</script>

<style scoped></style>
